/* eslint-disable @next/next/no-img-element */
import cn from 'classnames'
import Link from 'next/link'
import { FC, useState } from 'react'
import { useRouter } from 'next/router'
import s from './profileUserNav.module.css'
import ClickOutside from '@lib/click-outside'
import { useTranslations } from 'next-intl'
import useLogout from '@framework/auth/use-logout'

const ProfileUserNav: FC = () => {
  const [display, setDisplay] = useState(false)
  const logout = useLogout()
  const {
    locale,
    locales,
    defaultLocale = 'de',
    asPath: currentPath
  } = useRouter()

  const handleLogout = () => {
    // @ts-ignore
    logout().then(r => {
      setDisplay(false)
    })
  }

  const t = useTranslations('Global')

  return (
    <ClickOutside active={display} onClick={() => setDisplay(false)}>
      <nav className={s.root + ' relative'}>
        <div
          className='flex items-center relative'
          onClick={() => setDisplay(!display)}
        >
          <button className={s.button}>
            <span className={'user_icon remi-icon icon-32-User-32 text-icon32 text-primary100'}></span>
          </button>
        </div>
        {display && <div className='absolute top-10 right-0 left-auto'>
          <div className={s.dropdownMenu + ' dropdownMenu'}>
            <ul>
              <li>
                <Link href={'/orders'} onClick={() => {setDisplay(false)}} className={cn(s.item) + ' item'}>{t('orders')}</Link>
              </li>
              {/*<li>*/}
              {/*  <Link href={'/account'} passHref>*/}
              {/*    <a onClick={() => {setDisplay(false)}} className={cn(s.item) + ' item'}>{t('accountSettings')}</a>*/}
              {/*  </Link>*/}
              {/*</li>*/}
              <li>
                <Link href={'/subscriptions'} onClick={() => {setDisplay(false)}} className={cn(s.item) + ' item'}>{t('subscriptions')}</Link>
              </li>
              <li>
                <Link href={'/auth/login'} onClick={() => {handleLogout()}} className={cn(s.item) + ' item'}>{t('logout')}</Link>
              </li>
            </ul>
          </div>
        </div>
        }
      </nav>
    </ClickOutside>
  )
}

export default ProfileUserNav
